// extracted by mini-css-extract-plugin
export default {"download-button":"ImageView_download-button__OGE9+"};